module.exports = __webpack_public_path__ + "static/img/aqzs53.cf272953.jpg";